export default "__VITE_ASSET__AMIkyPrR__"